import { Box, CircularProgress } from '@mui/material';
import { useState } from 'react';

import { User } from '@apiContract';

import { ICropperRef, ImageCropper } from '@components/ImageCropper';
import { ImagePreview } from '@uiKit/ImagePreview';

import { PieceAnnotations } from '../Capture/types';
import { sxCircleProgress, sxImageEditor } from './styles';

interface ImageEditorProps {
  imageBase64: string;
  croppingActive: boolean;
  cropperRef: React.MutableRefObject<ICropperRef | null> | undefined;
  actions: React.ReactNode;
  setOpenCvIsLoading?: (status: boolean) => void;
  isLoading?: boolean;
  annotations?: PieceAnnotations;
  recipient?: User;
  forceFetch?: boolean;
}

export const ImageEditor = ({
  imageBase64,
  actions,
  croppingActive = false,
  cropperRef,
  setOpenCvIsLoading,
  isLoading,
  annotations,
  forceFetch,
}: ImageEditorProps) => {
  const [image, setImage] = useState<string>();
  const [isForceFetchLoading, setIsForceFetchLoading] = useState(false);

  if (!image && forceFetch && !isForceFetchLoading) {
    setIsForceFetchLoading(true);
    fetch(imageBase64, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    })
      .then((response) => {
        return response.blob();
      })
      .then((imageBlob) => {
        const imageObjectURL = URL.createObjectURL(imageBlob);
        setImage(imageObjectURL);
        setIsForceFetchLoading(false);
      });
  }

  const isLoadingShow = (forceFetch && !image) || isForceFetchLoading || isLoading;

  if (isLoadingShow)
    return (
      <Box sx={sxCircleProgress}>
        <CircularProgress size={80} />
      </Box>
    );

  return (
    <Box className="rd-image-editor" sx={sxImageEditor(croppingActive)}>
      {croppingActive ? (
        <ImageCropper
          image={forceFetch ? image : imageBase64}
          cropperRef={cropperRef}
          setOpenCvIsLoading={setOpenCvIsLoading}
        />
      ) : (
        <ImagePreview imageDataUrl={imageBase64} annotations={annotations} />
      )}

      {actions}
    </Box>
  );
};
